import React from 'react';
import CustomerNote from "components/setup/CustomerNote";
import BillingCategoryList from "components/setup/BillingCategoryList";
import {currentUser, duckify} from "utils/duckify";

const BillingCategoryPage = ({currentUser, props}) => {
  return <React.Fragment>
    {currentUser.acl >= 4 && <CustomerNote isSuperAdmin={'true'} userName={currentUser.name} pageName={'billing_categories'}/>}
    <BillingCategoryList {...props}/>
  </React.Fragment>
}

const mapDucksToProps = () => ({ currentUser });
export default duckify(mapDucksToProps)(BillingCategoryPage);
